import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

export const createBooking = (payload) => api.post('/bookings', payload).then((r) => r.data);
export const createContact = (payload) => api.post('/contacts', payload).then((r) => r.data);
